{
    "dev": {
        "AssetMaintenancePostSubscriptionKey": "c08821ae1d344e559c56daddc4c68a21",
        "AssetMaintenanceSubscriptionKey": "c24a2f957f6c45a5b567cc8a222e1021",
        "clientId": "39a9d9be-38a2-4c94-9d26-ce352c7ce03d",
        "tenantId": "37a72eb7-1faf-49d3-9ddc-6b923b751bc0",
        "AssetMaintenanceKey": "d22c505defd64c7bad137e44bc44f204",
        "appInsightsInstrumentationKey": "63518083-902f-493d-9244-248743bfe4bd"
    },
    "prod": {
        "AssetMaintenancePostSubscriptionKey": "4d5d04db5932463b9b7648e3bfbd2af3",
        "AssetMaintenanceSubscriptionKey": "6ab38c0e8add4b279ed23d385c2f73a4",
        "clientId": "6592aae3-6352-4a14-9176-af94098ac959",
        "tenantId": "37a72eb7-1faf-49d3-9ddc-6b923b751bc0",
        "AssetMaintenanceKey": "01d89d950f9d41e8adda361806b80e17",
        "appInsightsInstrumentationKey": "2cef5fdb-3fa6-4e50-be0d-c476f175ee9f"
    }
}